import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcCalendar20 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m3 16.003v-10.011c0-.548.45-.998.997-.998h1.995v-.997c0-.547.45-.997.997-.997.567 0 1.017.45 1.017.997v.997h3.988v-.997c0-.547.45-.997 1.017-.997.548 0 .997.45.997.997v.997h1.995c.547 0 .997.45.997.998v10.01c0 .548-.45.998-.997.998h-12.006c-.547 0-.997-.45-.997-.997zm1.994-.997h10.012v-4.009h-10.012zm0-6.003h10.012v-2.014l-10.012.02z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcCalendar20;
